import React, { useEffect, useState } from 'react';
import styles from './estudio_olavotattoo.module.scss';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import img1 from './src/estudio/1.png';
import img2 from './src/estudio/2.png';
import img3 from './src/estudio/3.png';
import img4 from './src/estudio/4.png';
import img5 from './src/estudio/5.png';
import img6 from './src/estudio/6.png';
import img7 from './src/estudio/7.png';
import img8 from './src/estudio/8.png';
import img9 from './src/estudio/9.png';
import img10 from './src/estudio/10.png';
import img11 from './src/estudio/11.png';
import img12 from './src/estudio/12.png';
import img13 from './src/estudio/13.png';
import img14 from './src/estudio/14.png';
import img15 from './src/estudio/15.png';

const images = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15
];

const Estudio_olavotattoo: React.FC = () => {
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openModal = (index: number) => setSelectedIndex(index);
    const closeModal = () => setSelectedIndex(null);
    const prevImage = () => setSelectedIndex((prev) => (prev! > 0 ? prev! - 1 : images.length - 1));
    const nextImage = () => setSelectedIndex((prev) => (prev! < images.length - 1 ? prev! + 1 : 0));

    return (
        <div className={styles.estudio_olavotattoo}>
            <div className={styles.header}>
                <Link to="/olavotattoo" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h1>Estúdio</h1>
                <div className={styles.line}></div>
            </div>

            <div className={styles.gallery}>
                {images.map((src, index) => (
                    <div className={styles.imageWrapper} key={index} onClick={() => openModal(index)}>
                        <img src={src} alt={`Foto ${index + 1}`} />
                    </div>
                ))}
            </div>

            {selectedIndex !== null && (
                <div className={styles.modal}>
                    <button className={styles.close} onClick={closeModal}>
                        <FaTimes />
                    </button>
                    <button className={styles.prev} onClick={prevImage}>
                        <FaChevronLeft />
                    </button>
                    <img src={images[selectedIndex]} alt={`Foto ampliada ${selectedIndex + 1}`} />
                    <button className={styles.next} onClick={nextImage}>
                        <FaChevronRight />
                    </button>
                </div>
            )}
        </div>
    );
};

export default Estudio_olavotattoo;
